export default "__VITE_ASSET__c6d9dd0c__"